import { useEffect, useState } from "react";

import { DS_COMPONENT_PREFIX } from "./constants";

export const useComponentsOnPage = () => {
  const [components, setComponents] = useState<Map<string, number>>(new Map());

  useEffect(() => {
    const elements = document.querySelectorAll("[class]");
    const componentCounts = new Map<string, number>();

    elements.forEach((element) => {
      const fiberKey = Object.keys(element).find((key) => key.startsWith("__reactFiber$"));

      if (!fiberKey) return;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const instance = (element as any)[fiberKey];
      if (!instance) return;

      let fiber = instance;
      while (fiber) {
        if (fiber.type?.displayName?.startsWith(DS_COMPONENT_PREFIX)) {
          const displayName = fiber.type.displayName;
          componentCounts.set(displayName, (componentCounts.get(displayName) || 0) + 1);
        }
        fiber = fiber.return;
      }
    });

    setComponents(componentCounts);
  }, []);

  return components;
};
